export const BASE_PATH = rmVars.siteSlug;
export const API = {
	URL: 'http://203.245.41.78:8001',
}

export const JOURNAL_FACET_NAME = {
	'dept': '학과 검색',
	'jcr_category': 'JCR Category',
	'journal_ranking': '저널 랭킹',
	'kci_category': 'KCI Category',
	'scopus_category': 'Scopus Category',
	'publisher': '출판사 검색',
	'registered_db_name': '등재DB',
	'registered_db_year': '등재연도',
	'journal_status' : '상태',
	'worker_name' : '작업자 이름'
}

export const RESOURCE_FACET_NAME = {
	'collabo_org': '공동연구기관',
	'cited_count': '피인용수',
	'resource_type': '자료유형',
	'publisher': '출판사',
	'registered_db': '등재유형',
	'dept': '학과',
	'publish_year': '출판연도',
	'scholar': '연구자',
	'author_count': '저자수',
	'resource_status' : '상태',
	'worker_name' : '작업자 이름',
	'sendmail_co' : '공저홍보 메일발송',
	'sendmail_my' : '본인확인 메일발송',
}

export const SCHOLAR_FACET_NAME = {
	'collabo_org': '공동연구기관',
	'sinbun_name': '신분',
	'dept_name': '학과',
	'scholar_status' : '상태',
	'worker_name' : '작업자 이름'
}

export const FACET_ORDER = ["registered_db_name", "registered_db_year", "jcr_category", "scopus_category", "kci_category", "dept", "publisher", "journal_ranking"];
export const FACET_ADMIN_ORDER = ["journal_status", "worker_name", "registered_db_name", "registered_db_year", "jcr_category", "scopus_category", "kci_category", "dept", "publisher", "journal_ranking"];
export const RESOURCE_FACET_ADMIN_ORDER = ["resource_status", 'sendmail_my', 'sendmail_co', "worker_name", "registered_db", "publish_year", "resource_type", "collabo_org", "cited_count", "publisher", "dept", "scholar", "author_count"];
export const RESOURCE_FACET_ORDER = ["registered_db", "publish_year", "cited_count", "resource_type", "collabo_org", "publisher",  "dept", "scholar", "author_count"];
export const SCHOLAR_FACET_ORDER = ["collabo_org", "sinbun_name", "dept_name"];
export const SCHOLAR_FACET_ADMIN_ORDER = ["scholar_status", "worker_name", "collabo_org", "sinbun_name", "dept_name"];

export const AUTHORITY_FACET_NAME = {
	'term_name': '유형',
	'term_status': '상태',
	'position_name': '포지션'
}

export const JOURNAL_ORDER_BY_OPTIONS = [
	{name: '랭킹순', value: 'ranking'},
	{name: '가나다', value: 'title'},
	{name: '등재순', value: 'date'}
];

export const RESOURCE_ORDER_BY_OPTIONS = [
	{name: '발행 최신순', value: 'publish_date'},
	{name: '반입 최신순', value: 'input_date'},
	{name: '가나다', value: 'title'},
	{name: '랭킹순', value: 'ranking'}
];

export const SCHOLAR_ORDER_BY_OPTIONS = [
	{name: '최신순', value: 'date'},
	{name: '가나다', value: 'title'},
	{name: '논문수', value: 'count'}
];

export const ORDER = [{name: '오름차순', value: 'asc'}, {name: '내림차순', value: 'desc'}];

export const MESSAGE = {
	'DELETE' : '삭제하시겠습니까?'
}

export const EDIT_MODE = {
	SHOW : 0,
	SHOW_EDIT : 1,
	SAVE_EDIT : 2,
}

export const SCROLL_OFFSET = 100;

export const QuestionCategory = {
	'MY_ARTICEL' : '내 논문 문의',
	'MY_ID' : '내 아이디 문의',
	'GENERAL' : '기타 문의',
}

export const STATUS_NAME = {
	'publish' : '완료',
	'draft' : '임시저장',
	// 'auto-draft' : '자동 저장',
	'unpublish' : '비공개',
	'trash' : '휴지통',
	'delete' : '삭제'
}

export const IMPORT_STATUS_NAME = {
	'parse' : '반입 및 분해',
	'artificial' : '변환',
	'verify' : '검증',
	'import' : '반입'
}